import colors from 'styles/_colors.scss';

export function GetOrderStatusColor(orderStatus: string)
{
	if (orderStatus.toLowerCase() === 'sh') {
		return colors.succesColor;
	} else {
		return colors.warningColor;
	}
}

export function GetOrderStatusColorClass(orderStatus: string)
{
	if (orderStatus.toLowerCase() === 'sh') {
		return " color-succes";
	} else {
		return " color-warn";
	}
}

export function GetDeliveryStatusColorClass(deliveryStatusId: string)
{
	switch (deliveryStatusId.toLowerCase()) {
		case 'sh':
		case 'in': {
			return " color-succes";
		}
		default: {
			return " color-warn";
		}
	}
}

export function GetInvoiceStatusColorClass(invoiceStatusId: string)
{
	switch (invoiceStatusId.toLowerCase()) {
		case 'pa': {
			return " color-succes";
		}
		default: {
			return " color-warn";
		}
	}
}